import helpers from "@/helpers"
var images = require.context("@/assets/gamer-life-icons/", false, /\.svg$/);

export default {
  name: "line-chart",
  components: {},
  props: {
    stat: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      dummyData: false,
      filename: "file",
      // for optio§ns: https://apexcharts.com/docs/options/chart/toolbar/
      options: {
        chart: {
          foreColor: '#373d3f',
          toolbar: {
            // autoSelected: "pan",
            tools: {
              download: `<img src='${images(
                "./download.svg"
              )}' width=40 />`,
              reset: `<img src='${images(
                "./reset.svg"
              )}' width=40 />`,
              zoom: `<img src='${images(
                "./search.svg"
              )}' width=40 />`,
              zoomin: `<img src='${images(
                "./plus.svg"
              )}' width=40 />`,
              zoomout: `<img src='${images(
                "./minus.svg"
              )}' width=40 />`,
              pan: `<img src='${images(
                "./pan.svg"
              )}' width=40 />`,
            },
            export: {
              csv: {
                filename: this.fileName,
              },
              svg: {
                filename: this.fileName,
              },
              png: {
                filename: this.fileName,
              },
            },
          },
          id: "Chart",
        },
        theme: {
          palette: "palette4",
        },
        stroke: {
          curve: "smooth",
        },
        dataLabels: {
          enabled: false,
        },
      },
      series: [
        {
          name: "Reservations",
          data: [],
        },
      ],
    };
  },
  computed: {
    org () {
      return this.$store.getters.activeOrg
    },
    dynamicLogs() {
      return this.$store.state.logs.boundFile &&
        this.$store.state.logs.boundFile.events
        ? this.$store.state.logs.boundFile.events.slice(0, 10)
        : [];
    },
    staticLogs() {
      return this.$store.state.logs.staticLogs.slice(
        0,
        10 - (this.dynamicLogs ? this.dynamicLogs.length : 0)
      );
    },
  },
  watch: {
    dynamicLogs() {
      this.reserveStats();
    },
    staticLogs() {
      this.reserveStats();
    },
  },
  mounted() {
    console.log("Mounting chart for:", this.stat);
    this.reserveStats();

    // update filename for image and CSV downloads
    this.fileName = `${this.org.name} - ${this.$t(this.statType)} - ${helpers.formatDate(null, "do MMM")}`
    // console.log('this.fileName:', this.fileName);
    
  },
  methods: {
    reserveStats() {
      if (
        !this.$store.state.logs.staticLogs ||
        !this.$store.state.logs.boundFile ||
        !this.$store.state.logs.boundFile.events
      ) {
        console.log("cancelling reservstats, missing files")
        return;
      }

      if(this.dummyData){
        // we've already loaded in some dummy data
        // if logs now have reservations, then cancel dummy data
        // if not, don't do anything as we already have dummy data
      }

      let a = this.$store.state.logs.staticLogs;
      let b = this.$store.state.logs.boundFile.events;

      let both = a.concat(b);
      both = both.filter((ev) => ev.n === "reservation.placed");
      let statsObj = {};

      if(!both.length){
        // we've no events, generate some dummy data
        if(this.dummyData){
          // we already have dummy data, no need to update
          return
        }
        this.dummyData = true
        for (let index = 1; index < 15; index++) {
          statsObj[new Date().getTime() - 86400000 * index] =
            Math.round(Math.random() * (40 - 15) + 15);
        }
      } else {
        both.forEach((ev) => {
          if (!statsObj[ev.d.startTime]) {
            statsObj[ev.d.startTime] = 1;
          } else {
            statsObj[ev.d.startTime]++;
          }
        });
      }

      // console.log("statsObj:", statsObj);

      let newOptions = {
        xaxis: {
          categories: []
        }
      }

      let newSeries = [
        {
          name: "Reservations",
          data: []
        }
      ]

      for (let key in statsObj) {
        let formatted = helpers.formatDate(key, "d MMM");
        // console.log('formatted:', formatted);
        newOptions.xaxis.categories.push(formatted);        
        newSeries[0]["data"].push(statsObj[key]);        
      }      

      this.options = {...this.options, ...newOptions}
      this.series = newSeries;
      // console.log('this.options now:', this.options);
      // console.log('this.series now:', this.series);
      
    },
  },
};
